<ms-my-bets-filter-button
    [toggleResponsiveFilter]="toggleResponsiveFilter"
    [filterConstraint]="filterConstraint"
    [myBetsListContext]="myBetsListContext"
    [betslipsCount]="betslipsCount"
    (filterButtonClicked)="showFilter()"
    (printButtonClicked)="print()"
    (constraintRemoved)="onConstraintRemoved($event)" />
<ms-my-bets-settled-filters
    *ngIf="toggleResponsiveFilter && isResponsiveMode"
    [toDate]="props.toDate"
    [fromDate]="props.fromDate"
    [stateModel]="props.stateModel"
    [isRangeSet]="isRangeSet"
    (requestResults)="onFilter($event)" />
